"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = require("react");

var _material = require("@mui/material");

var _lodash = _interopRequireDefault(require("lodash.keyby"));

var _Protraction = require("../Protraction");

var _DataTableSortLabel = _interopRequireDefault(require("./DataTableSortLabel"));

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DataTableHead = function DataTableHead(_ref) {
  var _ref$checkbox = _ref.checkbox,
      checkbox = _ref$checkbox === void 0 ? false : _ref$checkbox,
      checkboxState = _ref.checkboxState,
      checkboxAriaLabel = _ref.checkboxAriaLabel,
      columns = _ref.columns,
      linkRenderer = _ref.linkRenderer,
      setSortBy = _ref.setSortBy,
      setCheckboxState = _ref.setCheckboxState,
      _ref$sortBy = _ref.sortBy,
      sortBy = _ref$sortBy === void 0 ? [] : _ref$sortBy,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$radio = _ref.radio,
      radio = _ref$radio === void 0 ? false : _ref$radio;
  var sortByIndexed = (0, _react.useMemo)(function () {
    return (0, _lodash.default)(sortBy, "id");
  }, [sortBy]);

  var handleSortClick = function handleSortClick(id) {
    setSortBy(function (prevState) {
      var rule = prevState.find(function (obj) {
        return obj.id === id;
      }); // If the column is not being sorted, set to "asc"

      if (!rule) {
        return [].concat((0, _toConsumableArray2.default)(prevState), [{
          direction: "asc",
          id: id
        }]);
      } // If the column sort direction is "asc", set to "desc"


      if (rule.direction === "asc") {
        return prevState.map(function (obj) {
          return obj.id === id ? _objectSpread(_objectSpread({}, obj), {}, {
            direction: "desc"
          }) : obj;
        });
      } // If the column sort direction is "desc", remove the sort rule


      return prevState.filter(function (obj) {
        return obj.id !== id;
      });
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableHead, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.TableRow, {
      children: [radio && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableCell, {
        padding: "checkbox",
        style: {
          minWidth: 60
        }
      }), checkbox && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableCell, {
        padding: "checkbox",
        style: {
          minWidth: 60
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Checkbox, {
          "aria-label": checkboxAriaLabel,
          checked: checkboxState === "checked",
          indeterminate: checkboxState === "indeterminate",
          onChange: function onChange(event) {
            event.target.checked ? setCheckboxState("checked") : setCheckboxState("unchecked");
          }
        })
      }), columns && columns.map(function (_ref2) {
        var id = _ref2.id,
            label = _ref2.label,
            isSortable = _ref2.isSortable,
            sx = _ref2.sx,
            DataTableSortLabelProps = _ref2.DataTableSortLabelProps;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableCell, {
          sx: sx,
          children: isSortable ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DataTableSortLabel.default, _objectSpread({
            active: !!sortByIndexed[id],
            direction: sortByIndexed[id] && sortByIndexed[id].direction,
            disabled: disabled,
            label: label,
            onClick: function onClick() {
              return handleSortClick(id);
            }
          }, DataTableSortLabelProps)) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Protraction.Protraction, {
            disabled: disabled,
            variant: "button",
            children: label
          })
        }, id);
      }), linkRenderer && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableCell, {})]
    })
  });
};

var _default = DataTableHead;
exports.default = _default;